import { render, staticRenderFns } from "./Lender.vue?vue&type=template&id=d4bf122a"
import script from "./Lender.vue?vue&type=script&lang=js"
export * from "./Lender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports